import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core'
import { SessionService } from '@app/core'

@Component({
  selector: 'app-logout',
  // eslint-disable-next-line @angular-eslint/prefer-on-push-component-change-detection -- relies on pre-v22 default
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.scss'],
  standalone: false,
})
export class LogoutComponent implements OnInit {
  constructor(private sessionService: SessionService) {}

  ngOnInit(): void {
    this.sessionService.logout()
  }
}
